module.exports = __webpack_public_path__ + "static/SöhneBreit-Buch-f45c7dafd891eb16068ae5590690afd4.otf";